export default "__VITE_ASSET__bUUPQgRe__"